module.exports = __webpack_public_path__ + "static/media/logo.06f4d542.png";